import { Box, Typography } from '@mui/material';
import * as d3 from 'd3';
import { RACE_COLORS } from './heatmapTimeBins';

export function TotalLegend({ colorScales }: { colorScales: { total: d3.ScaleSequential<string> } | null }) {
  const steps = [0, 0.2, 0.4, 0.6, 0.8, 1];
  const [lo, hi] = colorScales?.total.domain() ?? [0, 1];

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
        <Typography variant='caption' sx={{ color: '#12294C', fontWeight: 500, fontSize: '10px' }}>
          LOW
        </Typography>
        {steps.map((t) => (
          <Box
            key={t}
            sx={{
              width: 24,
              height: 18,
              borderRadius: '2px',
              backgroundColor: colorScales ? colorScales.total(lo + t * (hi - lo)) : '#ccc',
            }}
          />
        ))}
        <Typography variant='caption' sx={{ color: '#12294C', fontWeight: 500, fontSize: '10px' }}>
          HIGH
        </Typography>
      </Box>
      <NoDataSwatch />
    </>
  );
}

export function RaceLegend({ races }: { races: string[] }) {
  return (
    <>
      {races.slice(0, 4).map((race) => {
        const c = RACE_COLORS[race] ?? { h: 200, s: 0.5, l: 0.5 };
        return (
          <Box key={race} sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <Box
              sx={{
                width: 24,
                height: 18,
                borderRadius: '2px',
                backgroundColor: `hsl(${c.h}, ${c.s * 100}%, ${c.l * 100}%)`,
              }}
            />
            <Typography
              variant='caption'
              sx={{ color: '#12294C', fontSize: '10px', textTransform: 'uppercase', fontWeight: 500 }}
            >
              {race}
            </Typography>
          </Box>
        );
      })}
      <NoDataSwatch />
    </>
  );
}

export function NoDataSwatch() {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px', marginLeft: '18px' }}>
      <Box
        sx={{
          width: 24,
          height: 18,
          borderRadius: '2px',
          backgroundImage: `repeating-linear-gradient(-45deg, #D3D8E1 0px, #D3D8E1 1px, #F4F5F7 1px, #F4F5F7 4px)`,
        }}
      />
      <Typography variant='caption' sx={{ color: '#12294C', fontSize: '10px', fontWeight: 500 }}>
        NO DATA
      </Typography>
    </Box>
  );
}
